import classnames from 'classnames/bind'
import React from 'react'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'
import { ctaNegativeTheme } from '~/lib/negative-theme-colors'

import Cta, { BaseProps } from '~/components/Abstracts/Cta'

import { useStyle } from '~/providers/StyleProvider'
import { useTheme } from '~/providers/ThemeProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

type SquaredCtaTextStyling =
  | typeof GlobalTextStyling.UpperCase
  | typeof GlobalTextStyling.Capitalize

export type SquaredCtaTextPreset =
  | typeof GlobalTextPreset.Cta16_12SangBleu
  | typeof GlobalTextPreset.Cta12Grotesk

export type SquaredCtaColors = GlobalThemeColors
export type SquaredCtaProps = BaseProps & {
  className?: string
  theme?: SquaredCtaColors
  textPreset?: SquaredCtaTextPreset
  textStyling?: SquaredCtaTextStyling
}

function SquaredCta({
  className,
  textPreset,
  textStyling,
  ...rest
}: SquaredCtaProps) {
  const { colors } = useTheme()
  const props = {
    css,
    cx,
    negativeColor: colors[ctaNegativeTheme(rest.theme)],
  }

  const textStyle = useStyle({
    textPreset,
    textStyling,
  })

  return (
    <Cta
      className={cx(
        className,
        textStyle,
        css.SquaredCta,
        css[rest?.spinnerClassName],
      )}
      {...props}
      {...rest}
    />
  )
}

SquaredCta.defaultProps = {
  theme: GlobalThemeColors.Black,
  textPreset: GlobalTextPreset.Cta12Grotesk,
  textStyling: GlobalTextStyling.UpperCase,
  withBackground: false,
  withBorder: true,
}

export default SquaredCta
